<template>
  <div>
    <!--Banner Parallax-->
    <section class="topBanner" ref="parallaxBanner" :style="{ backgroundPositionY: parallaxOffset + 'px' }">
      <div class="bannerOverlay">
        <h1 class="bannerTitle">{{ $t('intro.title') }}</h1>
      </div>
    </section>

    <!--Intro-->
    <section class="gridpad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="10">
          <p class="txt-j mt-5" v-html="$t('intro.txt')"></p>
        </v-col>
      </v-row>
    </section>

    <!--SubmersiblePump-->
    <section id="submersible" class="v-tierce2 sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Products/summersiblePump.jpg')">
            <div class="subImg photoImg">
              <div class="photoHoverOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('submersiblePump.title') }}</h2>
            <p v-html="$t('submersiblePump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('submersiblePump.ol1')"></li>
              <li v-html="$t('submersiblePump.ol2')"></li>
              <li v-html="$t('submersiblePump.ol3')"></li>
              <li v-html="$t('submersiblePump.ol4')"></li>
              <li v-html="$t('submersiblePump.ol5')"></li>
              <li v-html="$t('submersiblePump.ol6')"></li>
            </ol>
            <p v-html="$t('submersiblePump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('submersiblePump.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Égout-->
    <section id="sewer" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('sewerPump.title') }}</h2>
            <p v-html="$t('sewerPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('sewerPump.ol1')"></li>
              <li v-html="$t('sewerPump.ol2')"></li>
              <li v-html="$t('sewerPump.ol3')"></li>
              <li v-html="$t('sewerPump.ol4')"></li>
              <li v-html="$t('sewerPump.ol5')"></li>
              <li v-html="$t('sewerPump.ol6')"></li>
            </ol>
            <p v-html="$t('sewerPump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('sewerPump.btn')"></p></router-link>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Pumps/pompeEgout.jpg')">
            <div class="sewerImg photoImg">
              <div class="photoHoverOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Puisard-->
    <section id="Sump" class="v-primary-light-1 sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="8" class="d-flex justify-center align-center">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('sumpPump.title') }}</h2>
            <p v-html="$t('sumpPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('sumpPump.ol1')"></li>
              <li v-html="$t('sumpPump.ol2')"></li>
              <li v-html="$t('sumpPump.ol3')"></li>
              <li v-html="$t('sumpPump.ol4')"></li>
            </ol>
            <p v-html="$t('sumpPump.subtxt')"></p>
            <ol class="olPad">
              <li v-html="$t('sumpPump.ol5')"></li>
              <li v-html="$t('sumpPump.ol6')"></li>
              <li v-html="$t('sumpPump.ol7')"></li>
              <li v-html="$t('sumpPump.ol8')"></li>
            </ol>
            <p v-html="$t('sumpPump.subtxt2')"></p>
            <ul class="olPad">
              <li v-html="$t('sumpPump.ol9')"></li>
              <li v-html="$t('sumpPump.ol10')"></li>
              <li v-html="$t('sumpPump.ol11')"></li>
              <li v-html="$t('sumpPump.ol12')"></li>
              <li v-html="$t('sumpPump.ol13')"></li>
            </ul>
            <p v-html="$t('sumpPump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('otherPump.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
      <v-row class="pb-10">
        <v-col cols="12" class="pa-0 d-flex justify-center flex-wrap gap-4">
          <div v-for="(item, i) in puisardPumps" :key="i" class="pumpThumbCard" @click="openLightbox(item.img)">
            <img class="pumpThumbImg" :src="item.img"/>
            <div class="pumpThumbOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Piston-->
    <section id="piston" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="d-flex justify-center align-center">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('pistonPump.title') }}</h2>
            <p v-html="$t('pistonPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('pistonPump.ol1')"></li>
              <li v-html="$t('pistonPump.ol2')"></li>
              <li v-html="$t('pistonPump.ol3')"></li>
              <li v-html="$t('pistonPump.ol4')"></li>
            </ol>
            <p v-html="$t('pistonPump.subtxt')"></p>
            <ol class="olPad">
              <li v-html="$t('pistonPump.ol5')"></li>
              <li v-html="$t('pistonPump.ol6')"></li>
              <li v-html="$t('pistonPump.ol7')"></li>
              <li v-html="$t('pistonPump.ol8')"></li>
              <li v-html="$t('pistonPump.ol9')"></li>
            </ol>
            <p v-html="$t('pistonPump.bottomTxt')"></p>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Pumps/pompePiston.jpg')">
            <div class="pistonImg photoImg">
              <div class="photoHoverOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--ContactUs-->
    <contactUs/>

    <!--Prominent-->
    <section id="prominent" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Pumps/pompeProminent.jpg')">
            <div class="prominentImg photoImg">
              <div class="photoHoverOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('prominentPump.title') }}</h2>
            <p v-html="$t('prominentPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('prominentPump.ol1')"></li>
              <li v-html="$t('prominentPump.ol2')"></li>
              <li v-html="$t('prominentPump.ol3')"></li>
              <li v-html="$t('prominentPump.ol4')"></li>
              <li v-html="$t('prominentPump.ol5')"></li>
              <li v-html="$t('prominentPump.ol6')"></li>
              <li v-html="$t('prominentPump.ol7')"></li>
            </ol>
            <p v-html="$t('prominentPump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('sewerPump.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Sécurité-->
    <section id="security" class="v-tierce2 sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="8" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('securityPump.title') }}</h2>
            <p v-html="$t('securityPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('securityPump.ol1')"></li>
              <li v-html="$t('securityPump.ol2')"></li>
              <li v-html="$t('securityPump.ol3')"></li>
              <li v-html="$t('securityPump.ol4')"></li>
              <li v-html="$t('securityPump.ol5')"></li>
              <li v-html="$t('securityPump.ol6')"></li>
              <li v-html="$t('securityPump.ol7')"></li>
            </ol>
            <p v-html="$t('securityPump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('securityPump.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
      <v-row class="pb-10">
        <v-col cols="12" class="pa-0 d-flex justify-center flex-wrap gap-4">
          <div v-for="(item, i) in securityPumps" :key="i" class="pumpThumbCard" @click="openLightbox(item.img)">
            <img class="pumpThumbImg" :src="item.img"/>
            <div class="pumpThumbOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Circulation Chauffage-->
    <section id="traffic" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="d-flex justify-center align-center">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('trafficPump.title') }}</h2>
            <p v-html="$t('trafficPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('trafficPump.ol1')"></li>
              <li v-html="$t('trafficPump.ol2')"></li>
              <li v-html="$t('trafficPump.ol3')"></li>
              <li v-html="$t('trafficPump.ol4')"></li>
              <li v-html="$t('trafficPump.ol5')"></li>
              <li v-html="$t('trafficPump.ol6')"></li>
              <li v-html="$t('trafficPump.ol7')"></li>
            </ol>
            <p v-html="$t('trafficPump.bottomTxt')"></p>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Products/armstrong.jpg')">
            <div class="trafficImg photoImg">
              <div class="photoHoverOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--ContactUs-->
    <contactUs/>

    <!--Diaphragme-->
    <section id="diaphragm" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Pumps/pompeDiaphragme.jpg')">
            <div class="diaphragmImg photoImg">
              <div class="photoHoverOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('diaphragmPump.title') }}</h2>
            <p v-html="$t('diaphragmPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('diaphragmPump.ol1')"></li>
              <li v-html="$t('diaphragmPump.ol2')"></li>
              <li v-html="$t('diaphragmPump.ol3')"></li>
              <li v-html="$t('diaphragmPump.ol4')"></li>
            </ol>
            <p v-html="$t('diaphragmPump.subtxt')"></p>
            <ol class="olPad">
              <li v-html="$t('diaphragmPump.ol5')"></li>
              <li v-html="$t('diaphragmPump.ol6')"></li>
              <li v-html="$t('diaphragmPump.ol7')"></li>
              <li v-html="$t('diaphragmPump.ol8')"></li>
              <li v-html="$t('diaphragmPump.ol9')"></li>
              <li v-html="$t('diaphragmPump.ol10')"></li>
            </ol>
            <p v-html="$t('diaphragmPump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('diaphragmPump.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Transfert-->
    <section id="transfer" class="v-primary-light-1 sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="8" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('transferPump.title') }}</h2>
            <p v-html="$t('transferPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('transferPump.ol1')"></li>
              <li v-html="$t('transferPump.ol2')"></li>
              <li v-html="$t('transferPump.ol3')"></li>
              <li v-html="$t('transferPump.ol4')"></li>
              <li v-html="$t('transferPump.ol5')"></li>
              <li v-html="$t('transferPump.ol6')"></li>
              <li v-html="$t('transferPump.ol7')"></li>
            </ol>
            <p v-html="$t('transferPump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('transferPump.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
      <v-row class="pb-10">
        <v-col cols="12" class="pa-0 d-flex justify-center flex-wrap gap-4">
          <div v-for="(item, i) in transfertPumps" :key="i" class="pumpThumbCard" @click="openLightbox(item.img)">
            <img class="pumpThumbImg" :src="item.img"/>
            <div class="pumpThumbOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Piscine-->
    <section id="pool" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Pumps/pompePiscine.jpg')">
            <div class="poolImg photoImg">
              <div class="photoHoverOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('poolPump.title') }}</h2>
            <p v-html="$t('poolPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('poolPump.ol1')"></li>
              <li v-html="$t('poolPump.ol2')"></li>
              <li v-html="$t('poolPump.ol3')"></li>
              <li v-html="$t('poolPump.ol4')"></li>
            </ol>
            <p v-html="$t('poolPump.subtxt')"></p>
            <ol class="olPad">
              <li v-html="$t('poolPump.ol5')"></li>
              <li v-html="$t('poolPump.ol6')"></li>
              <li v-html="$t('poolPump.ol7')"></li>
              <li v-html="$t('poolPump.ol8')"></li>
              <li v-html="$t('poolPump.ol9')"></li>
              <li v-html="$t('poolPump.ol10')"></li>
              <li v-html="$t('poolPump.ol11')"></li>
            </ol>
            <p v-html="$t('poolPump.bottomTxt')"></p>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--ContactUs-->
    <contactUs/>

    <!--Spa-->
    <section id="spa" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="d-flex justify-center align-center">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('spaPump.title') }}</h2>
            <p v-html="$t('spaPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('spaPump.ol1')"></li>
              <li v-html="$t('spaPump.ol2')"></li>
              <li v-html="$t('spaPump.ol3')"></li>
              <li v-html="$t('spaPump.ol4')"></li>
            </ol>
            <p v-html="$t('spaPump.subtxt')"></p>
            <ol class="olPad">
              <li v-html="$t('spaPump.ol5')"></li>
              <li v-html="$t('spaPump.ol6')"></li>
              <li v-html="$t('spaPump.ol7')"></li>
              <li v-html="$t('spaPump.ol8')"></li>
              <li v-html="$t('spaPump.ol9')"></li>
            </ol>
            <p v-html="$t('spaPump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('spaPump.btn')"></p></router-link>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Pumps/pompeSpa.jpg')">
            <div class="spaPumpImg photoImg">
              <div class="photoHoverOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Irrigation-->
    <section id="irrigation" class="v-tierce2 sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="8" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('irrigationPump.title') }}</h2>
            <p v-html="$t('irrigationPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('irrigationPump.ol1')"></li>
              <li v-html="$t('irrigationPump.ol2')"></li>
              <li v-html="$t('irrigationPump.ol3')"></li>
            </ol>
            <p v-html="$t('irrigationPump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('irrigationPump.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
      <v-row class="pb-10">
        <v-col cols="12" class="pa-0 d-flex justify-center flex-wrap gap-4">
          <div v-for="(item, i) in irrigationPumps" :key="i" class="pumpThumbCard" @click="openLightbox(item.img)">
            <img class="pumpThumbImg" :src="item.img"/>
            <div class="pumpThumbOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Booster-->
    <section id="booster" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('boosterPump.title') }}</h2>
            <p v-html="$t('boosterPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('boosterPump.ol1')"></li>
              <li v-html="$t('boosterPump.ol2')"></li>
              <li v-html="$t('boosterPump.ol3')"></li>
              <li v-html="$t('boosterPump.ol4')"></li>
              <li v-html="$t('boosterPump.ol5')"></li>
              <li v-html="$t('boosterPump.ol6')"></li>
            </ol>
            <p v-html="$t('boosterPump.bottomTxt')"></p>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Products/boosterPump.jpg')">
            <div class="boosterImg photoImg">
              <div class="photoHoverOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
            </div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--ContactUs-->
    <contactUs/>

    <!--Pompe à main-->
    <section id="handPump" class="sectionPad">
      <v-row>
        <v-col cols="12" lg="6" class="pa-0 d-flex align-center justify-center">
          <div class="photoCard" @click="openLightbox('/Resources/images/Pumps/pompeMain.jpg')">
            <div class="handPumpImg photoImg">
              <div class="photoHoverOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('handPump.title') }}</h2>
            <p v-html="$t('handPump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('handPump.ol1')"></li>
              <li v-html="$t('handPump.ol2')"></li>
              <ol type="a" class="olPad">
                <li v-html="$t('handPump.ol2a')"></li>
                <li v-html="$t('handPump.ol2b')"></li>
                <li v-html="$t('handPump.ol2c')"></li>
                <li v-html="$t('handPump.ol2d')"></li>
              </ol>
              <li v-html="$t('handPump.ol3')"></li>
              <li v-html="$t('handPump.ol4')"></li>
              <li v-html="$t('handPump.ol5')"></li>
              <li v-html="$t('handPump.ol6')"></li>
            </ol>
            <p v-html="$t('handPump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('handPump.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Turbine-->
    <section id="turbine" class="v-primary-light-1 sectionPad">
      <v-row class="d-flex justify-center">
        <v-col cols="12" lg="8" class="txt-j">
          <div class="padPump">
            <h2 class="pumpSectionTitle mb-2">{{ $t('turbinePump.title') }}</h2>
            <p v-html="$t('turbinePump.txt')"></p>
            <ol class="olPad">
              <li v-html="$t('turbinePump.ol1')"></li>
              <li v-html="$t('turbinePump.ol2')"></li>
              <li v-html="$t('turbinePump.ol3')"></li>
              <li v-html="$t('turbinePump.ol4')"></li>
            </ol>
            <p v-html="$t('turbinePump.bottomTxt')"></p>
            <router-link class="button mt-4 btn-c" to="/contact"><p class="buttonText" v-html="$t('turbinePump.btn')"></p></router-link>
          </div>
        </v-col>
      </v-row>
      <v-row class="pb-10">
        <v-col cols="12" class="pa-0 d-flex justify-center flex-wrap gap-4">
          <div v-for="(item, i) in turbinePumps" :key="i" class="pumpThumbCard" @click="openLightbox(item.img)">
            <img class="pumpThumbImg" :src="item.img"/>
            <div class="pumpThumbOverlay"><span class="zoomIcon"><svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="22" y2="22"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></span></div>
          </div>
        </v-col>
      </v-row>
    </section>

    <!--Distribution-->
    <distributors/>

    <!--Lightbox Popup-->
    <transition name="lightbox-fade">
      <div v-if="lightboxOpen" class="lightboxBackdrop" @click.self="closeLightbox">
        <div class="lightboxContainer">
          <button class="lightboxClose" @click="closeLightbox">&times;</button>
          <img class="lightboxImg" :src="lightboxSrc" alt="Photo pompe" />
        </div>
      </div>
    </transition>

  </div>
</template>

<style scoped>
  p { font-size: 18px; color: rgba(var(--menuColor), 0.6); }
  .gridpad { padding: 30px 100px 50px 100px; }
  .sectionPad { padding: 50px 0px; }
  .padPump { text-align: justify; padding: 15px 50px; }
  .olPad { padding: 0px 40px; }
  ol li, ul li { padding: 8px 0px; font-size: 18px; color: rgba(var(--menuColor), 0.6); }

  /*#region Banner Parallax*/
  .topBanner {
    height: 600px;
    background-image: url('../../public/Resources/images/Banner/bannerResidentialPump.jpg');
    background-attachment: fixed;
    background-position: center 30%;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    will-change: background-position-y;
  }
  .bannerOverlay {
    background-color: rgba(0, 0, 0, 0.45);
    padding: 40px 70px;
    border-radius: 8px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    max-width: 700px;
  }
  .bannerTitle {
    color: #ffffff;
    font-weight: 700;
    font-size: 32px;
    text-transform: uppercase;
    letter-spacing: 2px;
    margin: 0;
  }
  /*#endregion*/

  /*#region Unified Section Titles*/
  .pumpSectionTitle { color: rgb(var(--secondary)); font-weight: 700; font-size: 26px; }
  /*#endregion*/

  /*#region Photo Cards + Hover*/
  .photoCard {
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0,0,0,0.18);
    cursor: pointer;
    width: 100%;
    max-width: 520px;
    margin: 20px auto;
  }
  .photoImg {
    height: 420px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #ffffff;
    transition: transform 0.4s ease;
    position: relative;
  }
  .photoCard:hover .photoImg { transform: scale(1.03); }
  .photoHoverOverlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0,0,0,0);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }
  .photoCard:hover .photoHoverOverlay { background-color: rgba(0,0,0,0.30); }
  .zoomIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    filter: drop-shadow(0 2px 6px rgba(0,0,0,0.6));
  }
  .photoCard:hover .zoomIcon { opacity: 1; }
  /*#endregion*/

  /*#region Image-specific backgrounds*/
  .subImg      { background-image: url("../../public/Resources/images/Products/summersiblePump.jpg"); }
  .sewerImg    { background-image: url("../../public/Resources/images/Pumps/pompeEgout.jpg"); background-size: cover; }
  .pistonImg   { background-image: url("../../public/Resources/images/Pumps/pompePiston.jpg"); }
  .prominentImg{ background-image: url("../../public/Resources/images/Pumps/pompeProminent.jpg"); background-size: cover; }
  .trafficImg  { background-image: url("../../public/Resources/images/Products/armstrong.jpg"); }
  .diaphragmImg{ background-image: url("../../public/Resources/images/Pumps/pompeDiaphragme.jpg"); }
  .poolImg     { background-image: url("../../public/Resources/images/Pumps/pompePiscine.jpg"); }
  .spaPumpImg  { background-image: url("../../public/Resources/images/Pumps/pompeSpa.jpg"); background-size: cover; }
  .boosterImg  { background-image: url("../../public/Resources/images/Products/boosterPump.jpg"); }
  .handPumpImg { background-image: url("../../public/Resources/images/Pumps/pompeMain.jpg"); }
  /*#endregion*/

  /*#region Pump Thumbnails (for galleries)*/
  .pumpThumbCard {
    position: relative;
    display: inline-block;
    margin: 8px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    box-shadow: 0 4px 16px rgba(0,0,0,0.2);
    border: 4px solid rgb(var(--secondary));
  }
  .pumpThumbImg { height: 170px; width: 200px; object-fit: cover; display: block; }
  .pumpThumbOverlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0,0,0,0);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease;
  }
  .pumpThumbCard:hover .pumpThumbOverlay { background-color: rgba(0,0,0,0.35); }
  .pumpThumbCard:hover .zoomIcon { opacity: 1; }
  /*#endregion*/

  /*#region Lightbox*/
  .lightboxBackdrop {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.88);
    z-index: 99999;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .lightboxContainer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000;
  }
  .lightboxImg {
    max-width: 88vw;
    max-height: 88vh;
    border-radius: 6px;
    box-shadow: 0 8px 40px rgba(0,0,0,0.6);
    object-fit: contain;
    display: block;
  }
  .lightboxClose {
    position: fixed;
    top: 20px;
    right: 28px;
    font-size: 44px;
    color: #ffffff;
    background: none;
    border: none;
    cursor: pointer;
    line-height: 1;
    opacity: 0.85;
    transition: opacity 0.2s;
    z-index: 100001;
  }
  .lightboxClose:hover { opacity: 1; }
  .lightbox-fade-enter-active, .lightbox-fade-leave-active { transition: opacity 0.25s ease; }
  .lightbox-fade-enter-from, .lightbox-fade-leave-to { opacity: 0; }
  /*#endregion*/

  .gap-4 { gap: 16px; }

  @media handheld, only screen and (max-width: 600px) {
    .gridpad { padding: 20px 15px 40px 15px; }
    .padPump { padding: 15px; }
    .olPad { padding: 0px 15px; }
    .topBanner { height: 400px; background-attachment: scroll; }
    .bannerTitle { font-size: 24px; }
    .bannerOverlay { padding: 25px 20px; }
    .photoImg { height: 260px; }
    .pumpThumbImg { height: 130px; width: 150px; }
  }
  @media handheld, only screen and (max-width: 960px) {
    .gridpad { padding: 20px 25px 40px 25px; }
    .sectionPad { padding: 30px 0px; }
    .padPump { padding: 15px 20px; }
    .topBanner { height: 500px; background-attachment: scroll; }
    .photoImg { height: 300px; }
  }
  @media handheld, only screen and (max-width: 1279px) {
    .gridpad { padding: 20px 40px 40px 40px; }
    .padPump { padding: 15px 30px; }
    .topBanner { height: 500px; background-attachment: scroll; }
  }
</style>

<script>
  import contactUs from '@/components/bannerContactUs.vue';
  import pageTranslations from '../../public/Resources/i18N/waterPump.json';
  import distributors from '../components/distributors.vue';
  import pumps from '../components/pumps.vue';

  export default {
    name: 'waterPump',
    data: () => ({
      parallaxOffset: 0,
      lightboxOpen: false,
      lightboxSrc: '',
      puisardPumps: [
        { img: '/Resources/images/Pumps/pompePuisard.jpg' }
      ],
      securityPumps: [
        { img: '/Resources/images/Pumps/pompePuisard-2.jpg' },
        { img: '/Resources/images/Pumps/pompeSecurity-2.jpg' }
      ],
      turbinePumps: [
        { img: '/Resources/images/Pumps/turbinePump.jpg' }
      ],
      irrigationPumps: [
        { img: '/Resources/images/Pumps/pompeIrrigation.jpg' }
      ],
      transfertPumps: [
        { img: '/Resources/images/Products/transfertPump.jpg' }
      ],
    }),
    mounted() {
      this.$i18n.mergeLocaleMessage('fr', pageTranslations.fr);
      this.$i18n.mergeLocaleMessage('en', pageTranslations.en);
      window.addEventListener('scroll', this.handleParallax);
      window.addEventListener('keydown', this.handleKeydown);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleParallax);
      window.removeEventListener('keydown', this.handleKeydown);
    },
    methods: {
      handleParallax() {
        if (!this.$refs.parallaxBanner) return;
        this.parallaxOffset = Math.round(window.scrollY * 0.4);
      },
      openLightbox(src) {
        this.lightboxSrc = src;
        this.lightboxOpen = true;
        document.body.style.overflow = 'hidden';
      },
      closeLightbox() {
        this.lightboxOpen = false;
        document.body.style.overflow = '';
      },
      handleKeydown(e) {
        if (!this.lightboxOpen) return;
        if (e.key === 'Escape') this.closeLightbox();
      },
    },
    components: {
      contactUs,
      distributors,
      pumps,
    },
  }
</script>